import { MatStepper } from "@angular/material/stepper";
import { STORAGE_KEY_ID_PERFIL } from "./../../storageCore/constStorageKeys";
import { ToolsService } from "./../../services/migrate/tools.service";
import { Component, OnInit, AfterViewInit } from "@angular/core";
import * as FileSaver from "file-saver";
import storageX from "../../storageCore/storageX";
import { Page } from "../../utils/paginate";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatAutocomplete } from "@angular/material/autocomplete";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CoreService } from "../../services/migrate/api.core.service";
import ApiService from "../../services/api.service";
import { Empresa } from "../../models/markerModel";
import { Params } from "../../services/migrate/params";
import { USER_DATA } from "../../utils/constants.util";
import { DriverReportMapComponent } from "../driver-report/driver-report-map.component";
import { MatDialog } from "@angular/material/dialog";
import { MapaDialogComponent } from "./mapa-dialog/mapa-dialog.component";

@Component({
  selector: "app-electronic-fence-report",
  templateUrl: "./electronic-fence-report.component.html",
  styleUrls: ["./electronic-fence-report.component.scss"],
})
export class ElectronicFenceReportComponent implements OnInit, AfterViewInit {
  public controlEmpresa = new FormControl();
  public controlVeiculo = new FormControl();

  public colsHeader = new Array<any>();
  public companys = new Array<any>();
  public companysFiltered = new Observable<Array<any>>();
  public vehicles = new Array<any>();
  public vehiclesFiltered = new Observable<Array<any>>();

  public empresaFilterSelected;
  public companiesFilter: any = [];

  public companiesSelect: any = [];

  private profileId = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();
  public paramsLoad = {
    profileId: this.profileId,
    size: 9999,
    page: 0,
    sort: "nome",
    sortDirection: "ASC",
  };

  public consultaFormGroup: FormGroup;

  public serviceCore: CoreService;
  public serviceApi: ApiService;

  public pagination = new Page();
  public matStepper: MatStepper;
  public matAutocomplete: MatAutocomplete;
  public filterDialog = true;
  public items;

  public resultado = new Array<any>();
  public resultadoAnalitico = new Array<any>();

  constructor(
    private tools: ToolsService,
    apiserviceCore: CoreService,
    serviceApi: ApiService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) {
    this.serviceCore = apiserviceCore;
    this.serviceApi = serviceApi;
  }

  ngAfterViewInit(): void {
    this.filterDialog = true;
  }

  ngOnInit() {
    this.pagination.currentPage = 0;
    this.pagination.size = 10;

    this.tools.builder().spinner.show();
    this.loadDataElements();

    this.consultaFormGroup = this.formBuilder.group({
      selecaoEmpresa: [""],
      dataInicio: ["", Validators.required],
      dataFim: ["", Validators.required],
      buscaPorEmpresa: [false],
    });

    this.onToggleBuscaPorEmpresa();

    this.companysFiltered = this.controlEmpresa.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.id)),
      map((name) =>
        name ? this.filterValuesEmpresa(name) : this.companys.slice()
      )
    );

    this.vehiclesFiltered = this.controlVeiculo.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.cdPlaca)),
      map((name) =>
        name ? this.filterValuesTerminal(name) : this.vehicles.slice()
      )
    );
  }

  onToggleBuscaPorEmpresa(): void {
    const buscaEmpresa = this.consultaFormGroup.get("buscaPorEmpresa")?.value;

    if (buscaEmpresa) {
      this.controlVeiculo.disable();
      this.controlVeiculo.setValue("");
    } else {
      this.controlVeiculo.enable();
    }
  }

  public filterValuesEmpresa(value: any): Array<any> {
    const filterValue = value;

    if (this.controlEmpresa.value.cnpj != null) {
      if (value != null) {
        this.loadFilterCompany(value);
      }
    } else {
      if (value != null) {
        this.loadFilterDivision(value);
      }
    }

    return this.companys
      .sort((a, b) => a.nmNome.localeCompare(b.nmNome))
      .filter((client) => client.nmNome.toLowerCase().includes(filterValue));
  }

  displayEmpresa(empresa: Empresa): string {
    return empresa && empresa.nmNome ? empresa.nmNome : "";
  }

  public filterValuesTerminal(value: string): Array<any> {
    const filterValue = value.toLowerCase();
    return this.vehicles
      .sort((a, b) => a.cdPlaca.localeCompare(b.cdPlaca))
      .filter((client) => client.cdPlaca.toLowerCase().includes(filterValue));
  }

  displayTerminal(terminal: any): string {
    var terminalPlaca = terminal.cdPlaca ? terminal.cdPlaca : "";
    var terminalFrota = terminal.frota ? terminal.frota : "";

    return terminal && terminal.cdPlaca
      ? terminalPlaca + "/" + terminalFrota
      : "";
  }

  public paginate(event) {
    const params = this.tools.builder().params;

    this.pagination.currentPage = event.page;
    this.pagination.size = event.rows;
  }

  public onOpenDialogFilter() {
    this.filterDialog = true;
  }

  abrirMapaDialog(rowdata: any): void {
    console.log("Clicou em posição:", rowdata);
    this.dialog.open(MapaDialogComponent, {
      width: "800px",
      data: rowdata, // passa o objeto inteiro direto
    });
  }

  exportPdf() {
    // Função para carregar a imagem e converter para base64
    const loadImageAsBase64 = (url) => {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
      });
    };

    // Função para adicionar o cabeçalho ao PDF
    const addHeader = (doc, imgData, data) => {
      const pageWidth = doc.internal.pageSize.width;

      // Dimensões da imagem
      const imgWidth = 40;
      const imgHeight = 40;

      const marginLeft = 200;
      const marginTop = 10;

      // Adicionando a imagem
      doc.addImage(imgData, "PNG", marginLeft, marginTop, imgWidth, imgHeight);

      var text = "";

      // Texto do cabeçalho
      if (this.resultadoAnalitico.length > 0) {
        text = "SETERA - RELATÓRIO ENTRADA E SAÍDA CERCA ELETRÔNICA";
      }

      const textX = marginLeft + imgWidth + 10;
      const textY = marginTop + imgHeight / 2 + 5;

      doc.setFontSize(18);
      doc.setTextColor("#0000FF");
      doc.setFont("helvetica", "bold");
      doc.text(text, textX, textY);
    };

    if (this.resultadoAnalitico.length > 0) {
      import("jspdf").then((jsPDF) => {
        import("jspdf-autotable").then(() => {
          const doc = new jsPDF.default("l", "pt");

          loadImageAsBase64("assets/img/logo-aba.png")
            .then((imgData) => {
              const header = (data) => {
                addHeader(doc, imgData, data);
              };

              doc.autoTable({
                startY: 60,
                html: ".tableAnalitico",
                useCss: true,
                didDrawPage: header,
                margin: { top: 60 },
              });

              addHeader(doc, imgData, { settings: { margin: { left: 40 } } });

              doc.save(
                `relatorio_gerencial_entrada_saida_cerca_eletronica.pdf`
              );
            })
            .catch((error) => {
              console.error("Erro ao carregar a imagem:", error);
            });
        });
      });
    }
  }

  exportExcel() {
    if (this.resultadoAnalitico.length > 0) {
      import("xlsx").then((xlsx) => {
        const worksheet = xlsx.utils.table_to_sheet(
          document.getElementsByClassName("tableAnalitico")[0],
          { dateNF: "mm/dd/yyyy hh:mm", cellDates: true }
        );
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        this.saveAsExcelFile(
          excelBuffer,
          `relatorio_gerencial_entrada_saida_cerca_eletronica`
        );
      });
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      `relatorio_gerencial_veiculo` +
        "_export_" +
        new Date().getTime() +
        EXCEL_EXTENSION
    );
  }

  public openMap(lat, long) {
    const dialogRef = this.dialog.open(DriverReportMapComponent, {
      width: "450px",
      height: "450px",
      data: {
        lat: lat,
        lng: long,
      },
    });
  }

  public onConsultar() {
    const buscaEmpresa = this.consultaFormGroup.get("buscaPorEmpresa")?.value;
    const isValidForm = this.consultaFormGroup.valid;

    if (
      isValidForm &&
      (buscaEmpresa || (!buscaEmpresa && this.controlVeiculo.value))
    ) {
      const params = new Params();

      const dataInicioRaw = this.consultaFormGroup.value.dataInicio;
      const dataFimRaw = this.consultaFormGroup.value.dataFim;

      // Converte para Date
      const dataInicio = new Date(dataInicioRaw);
      const dataFim = new Date(dataFimRaw);

      // Função auxiliar para garantir formatação completa
      const formatDateTime = (d: Date): string => {
        const pad = (n: number) => n.toString().padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
          d.getDate()
        )}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      };

      const startDate = formatDateTime(dataInicio);
      const endDate = formatDateTime(dataFim);

      if (buscaEmpresa) {
        const empresaSelecionada = this.controlEmpresa.value;
        const tipoEmpresa = this.empresaFilterSelected;

        if (tipoEmpresa === "Matriz" || tipoEmpresa === "Filial") {
          params.setParam("idEmpresa", empresaSelecionada.id);
        } else if (tipoEmpresa === "Divisão") {
          params.setParam("idDivisao", empresaSelecionada.id);
        }
      } else {
        params.setParam("idTerminal", this.controlVeiculo.value.id);
      }

      params.setParam("startDate", startDate);
      params.setParam("endDate", endDate);

      this.tools.builder().spinner.show();
      this.tools
        .builder()
        .api.get(
          `${this.tools.builder().api.getApiUrl().reports}/cerca-eletronica`,
          params.build()
        )
        .subscribe((r: any) => {
          this.resultadoAnalitico = r;
          this.resultado = new Array<any>();
          this.pagination = r.pagination;
          this.tools.builder().spinner.hide();
          this.filterDialog = false;
          if (this.resultadoAnalitico.length == 0) {
            this.tools
              .builder()
              .openToast.emitInf("Nenhum resultado para exibir no momento.");
          }
        });
    }
  }

  public async loadDataElements() {
    try {
      this.tools.builder().spinner.show();

      const companys = await this.serviceCore.get<any>({
        url: "v2/companys",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.companys = companys?.elements;
      this.companys = this.companys.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );
      this.controlEmpresa.setValue("");

      const terminals = await this.serviceCore.get<any>({
        url: "v2/terminals",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sortDirections: "ASC",
        },
      });

      this.vehicles = terminals.elements;
      // Filtra veículos com cdPlaca nulo ou vazio
      this.vehicles = this.vehicles.filter(vehicle => vehicle.cdPlaca && vehicle.cdPlaca.trim() !== '');
      this.vehicles = this.vehicles.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );
      this.controlVeiculo.setValue("");

      this.companiesSelect = [
        { name: "Divisão", value: 1 },
        { name: "Matriz", value: 2 },
        { name: "Filial", value: 3 },
      ];

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadFilterCompany(value: any) {
    try {
      this.tools.builder().spinner.show();

      const terminals = await this.serviceCore.get<any>({
        url: "v2/terminals/findByCompany",
        params: {
          profileId: USER_DATA().profileId,
          idEmpresa: value,
          size: "5000",
          page: "0",
          sortDirections: "ASC",
        },
      });

      console.log(terminals);

      this.vehicles = terminals.elements;
      // Filtra veículos com cdPlaca nulo ou vazio
      this.vehicles = this.vehicles.filter(vehicle => vehicle.cdPlaca && vehicle.cdPlaca.trim() !== '');
      this.vehicles = this.vehicles.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );

      this.controlVeiculo.setValue("");

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadFilterDivision(value: any) {
    try {
      this.tools.builder().spinner.show();

      const terminals = await this.serviceCore.get<any>({
        url: "v2/terminals/findByDivision",
        params: {
          profileId: USER_DATA().profileId,
          idDivisao: value,
          size: "5000",
          page: "0",
          sortDirections: "ASC",
        },
      });

      this.vehicles = terminals.elements;
      // Filtra veículos com cdPlaca nulo ou vazio
      this.vehicles = this.vehicles.filter(vehicle => vehicle.cdPlaca && vehicle.cdPlaca.trim() !== '');
      this.vehicles = this.vehicles.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );

      this.controlVeiculo.setValue("");

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async filterCompanyReports() {
    this.controlEmpresa.setValue("");
    var idEmpresa = this.empresaFilterSelected;
    var empresas: any = [];

    console.log(this.companysFiltered);

    if (idEmpresa == "Divisão") {
      this.companys.forEach((element) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Matriz") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Filial") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;

    this.companysFiltered.subscribe(this.companiesFilter);

    console.log(this.companysFiltered);
    console.log(this.companiesFilter);
  }
}
